<app-employee-goals *appHasModuleAccess="modules.PERFORMANCE" [employeeId]="employeeId"></app-employee-goals>